import React from "react";
import { useTranslation } from "react-i18next";
import "./CarruselNosotros.css";

export default function CarruselNosotros() {
  const { t } = useTranslation();

  return (
    <div className="carrusel-nosotros-container">
      <img
        src="/equipo2.webp"
        alt={t("carrusel_nosotros.alt_image")}
        className="carrusel-nosotros-img"
      />
      <div className="carrusel-nosotros-overlay">
        <h2 className="carrusel-nosotros-title">
          {t("carrusel_nosotros.title")}
          <br />
        </h2>
      </div>
    </div>
  );
}

